module.exports = __webpack_public_path__ + "img/question-template-icon.2ba16553.svg";